//Background Import
import blue from "../Image/background/blue.png";
import brown from "../Image/background/brown.png";
import green from "../Image/background/green.png";
import pink from "../Image/background/pink.png";
import yellow from "../Image/background/yellow.png";
import lowPink from "../Image/background/low_pink.png";
import darkGreen from "../Image/background/dark_green.png";
import red from "../Image/background/red.png";
import darkPink from "../Image/background/dark_pink.png";
import lightPink from "../Image/background/light_pink.png";
import darkDarkPink from "../Image/background/dark_dark_pink.png";
import lowLightPink from "../Image/background/low_light_pink.png";
import lowViolet from "../Image/background/low_violet.png";
import lightGreen from "../Image/background/light_green.png";

// Image Import
import img1 from "../Image/Image/1.png";
import img2 from "../Image/Image/2.png";
import img3 from "../Image/Image/3.png";
import img4 from "../Image/Image/4.png";
import img5 from "../Image/Image/5.png";
import img6 from "../Image/Image/6.png";
import img7 from "../Image/Image/7.png";
import img8 from "../Image/Image/8.png";
import img9 from "../Image/Image/9.png";
import img10 from "../Image/Image/10.png";
import img11 from "../Image/Image/11.png";
import img12 from "../Image/Image/12.png";
import img13 from "../Image/Image/13.png";
import img14 from "../Image/Image/14.png";
import img15 from "../Image/Image/15.png";

const SliderData = [
  {
    id: 1,
    image: img1,
    percent: "1%",
    desc: "uncommon",
    price: "5.00",
    symbol: "USDC",
    backgroundImage: blue,
    backgroundColour:
      "linear-gradient(0deg, rgba(38, 160, 251, 0.5), rgba(38, 160, 251, 0.5))",
  },
  {
    id: 2,
    image: img2,
    percent: "2%",
    desc: "uncommon",
    price: "5.00",
    symbol: "USDC",
    backgroundImage: brown,
    backgroundColour:
      "linear-gradient(0deg, rgba(38, 160, 251, 0.5), rgba(38, 160, 251, 0.5))",
  },
  {
    id: 3,
    image: img3,
    percent: "3%",
    desc: "uncommon",
    price: "5.00",
    symbol: "USDC",
    backgroundImage: green,
    backgroundColour:
      "linear-gradient(0deg, rgba(38, 160, 251, 0.5), rgba(38, 160, 251, 0.5))",
  },
  {
    id: 4,
    image: img4,
    percent: "4%",
    desc: "uncommon",
    price: "5.00",
    symbol: "USDC",
    backgroundImage: pink,
    backgroundColour:
      "linear-gradient(0deg, rgba(38, 160, 251, 0.5), rgba(38, 160, 251, 0.5))",
  },
  {
    id: 5,
    image: img5,
    percent: "5%",
    desc: "uncommon",
    price: "5.00",
    symbol: "USDC",
    backgroundImage: yellow,
    backgroundColour:
      "linear-gradient(0deg, rgba(38, 160, 251, 0.5), rgba(38, 160, 251, 0.5))",
  },
  {
    id: 6,
    image: img6,
    percent: "6%",
    desc: "uncommon",
    price: "5.00",
    symbol: "USDC",
    backgroundImage: lowPink,
    backgroundColour:
      "linear-gradient(0deg, rgba(38, 160, 251, 0.5), rgba(38, 160, 251, 0.5))",
  },
  {
    id: 7,
    image: img7,
    percent: "7%",
    desc: "uncommon",
    price: "5.00",
    symbol: "USDC",
    backgroundImage: darkGreen,
    backgroundColour:
      "linear-gradient(0deg, rgba(38, 160, 251, 0.5), rgba(38, 160, 251, 0.5))",
  },
  {
    id: 8,
    image: img8,
    percent: "8%",
    desc: "uncommon",
    price: "5.00",
    symbol: "USDC",
    backgroundImage: red,
    backgroundColour:
      "linear-gradient(0deg, rgba(38, 160, 251, 0.5), rgba(38, 160, 251, 0.5))",
  },
  {
    id: 9,
    image: img9,
    percent: "9%",
    desc: "uncommon",
    price: "5.00",
    symbol: "USDC",
    backgroundImage: darkPink,
    backgroundColour:
      "linear-gradient(0deg, rgba(38, 160, 251, 0.5), rgba(38, 160, 251, 0.5))",
  },
  {
    id: 10,
    image: img10,
    percent: "10%",
    desc: "uncommon",
    price: "5.00",
    symbol: "USDC",
    backgroundImage: lightPink,
    backgroundColour:
      "linear-gradient(0deg, rgba(38, 160, 251, 0.5), rgba(38, 160, 251, 0.5))",
  },
  {
    id: 11,
    image: img11,
    percent: "11%",
    desc: "uncommon",
    price: "5.00",
    symbol: "USDC",
    backgroundImage: darkDarkPink,
    backgroundColour:
      "linear-gradient(0deg, rgba(38, 160, 251, 0.5), rgba(38, 160, 251, 0.5))",
  },
  {
    id: 12,
    image: img12,
    percent: "12%",
    desc: "uncommon",
    price: "5.00",
    symbol: "USDC",
    backgroundImage: lowLightPink,
    backgroundColour:
      "linear-gradient(0deg, rgba(38, 160, 251, 0.5), rgba(38, 160, 251, 0.5))",
  },
  {
    id: 13,
    image: img13,
    percent: "13%",
    desc: "uncommon",
    price: "5.00",
    symbol: "USDC",
    backgroundImage: lowViolet,
    backgroundColour:
      "linear-gradient(0deg, rgba(38, 160, 251, 0.5), rgba(38, 160, 251, 0.5))",
  },
  {
    id: 14,
    image: img14,
    percent: "4%",
    desc: "uncommon",
    price: "14.00",
    symbol: "USDC",
    backgroundImage: lightGreen,
    backgroundColour:
      "linear-gradient(0deg, rgba(38, 160, 251, 0.5), rgba(38, 160, 251, 0.5))",
  },
  {
    id: 15,
    image: img15,
    percent: "5%",
    desc: "uncommon",
    price: "15.00",
    symbol: "USDC",
    backgroundImage: lightGreen,
    backgroundColour:
      "linear-gradient(0deg, rgba(38, 160, 251, 0.5), rgba(38, 160, 251, 0.5))",
  },
];

export default SliderData;
